module.exports = __webpack_public_path__ + "static/design-patterns-158d4f363abd5456fcff09fefd6162bb.jpg";